import { Link } from 'react-router-dom';
import SEOHead from '@/components/feature/SEOHead';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { categories } from '@/mocks/categories';

export default function About() {
  const breadcrumbItems = [
    { label: '首页', href: '/' },
    { label: '关于我们' },
  ];

  const orgLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '51CG吃瓜特色',
    url: typeof window !== 'undefined' ? window.location.origin : '',
    logo: `${typeof window !== 'undefined' ? window.location.origin : ''}/logo.png`,
    description: '汇集最新热门瓜料、明星黑料、娱乐爆料与网友热议话题的综合性吃瓜导航与深度解析平台。',
    sameAs: ['http://leonqt.com/'],
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: '商务合作',
      availableLanguage: 'Chinese',
    },
  };

  const webPageLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于我们 - 51CG吃瓜特色',
    url: typeof window !== 'undefined' ? window.location.href : '',
    description: '了解51CG吃瓜特色的品牌故事、平台定位、核心优势与联系方式。',
    isPartOf: { '@type': 'WebSite', name: '51CG吃瓜特色', url: typeof window !== 'undefined' ? window.location.origin : '' },
    mainEntity: { '@type': 'Organization', name: '51CG吃瓜特色' },
  };

  const breadcrumbLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: typeof window !== 'undefined' ? window.location.origin : '' },
      { '@type': 'ListItem', position: 2, name: '关于我们', item: typeof window !== 'undefined' ? window.location.href : '' },
    ],
  };

  const aboutFaqLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '51CG吃瓜特色是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '51CG吃瓜特色是汇集最新热门瓜料、明星黑料、娱乐爆料与网友热议话题的综合性吃瓜导航与深度解析平台，覆盖明星黑料、热门吃瓜、深度解析、娱乐爆料、莫里秀找爹五大专区。',
        },
      },
      {
        '@type': 'Question',
        name: '51CG吃瓜的内容来源可靠吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '51CG吃瓜对所有发布内容进行初步审核，标注信息来源。热门爆料会标注爆料标签，深度分析文章会提供证据链。我们鼓励读者保持独立思考，理性吃瓜。',
        },
      },
      {
        '@type': 'Question',
        name: '如何联系51CG吃瓜进行商务合作或投稿？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过页面底部的联系方式与我们取得联系。我们欢迎有价值的爆料投稿和商务合作洽谈。',
        },
      },
      {
        '@type': 'Question',
        name: '51CG吃瓜覆盖哪些内容领域？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '51CG吃瓜目前覆盖五大专区：明星黑料、热门吃瓜、深度解析、娱乐爆料、莫里秀找爹。每个专区都有专职编辑团队负责内容筛选与更新。',
        },
      },
    ],
  };

  return (
    <>
      <SEOHead
        title="关于我们 - 51CG吃瓜特色品牌介绍与联系方式"
        description="了解51CG吃瓜特色的品牌故事、平台定位、核心优势与联系方式。51CG吃瓜是汇集最新热门瓜料、明星黑料与娱乐爆料的综合性吃瓜导航与深度解析平台。"
        keywords="51CG吃瓜, 关于我们, 品牌介绍, 联系方式, 商务合作, 吃瓜平台"
        ogType="website"
        jsonLd={[orgLd, webPageLd, breadcrumbLd, aboutFaqLd]}
      />

      {/* Hero */}
      <section className="relative min-h-[300px] md:min-h-[380px] flex items-end overflow-hidden pt-20 md:pt-24 pb-8 md:pb-12">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20modern%20media%20headquarters%20building%20silhouette%20with%20lime%20green%20neon%20glow%20windows%20on%20dark%20night%20sky%2C%20entertainment%20news%20office%20concept%2C%20professional%20atmosphere%2C%20modern%20digital%20art%20style&width=1600&height=500&seq=about-hero-01&orientation=landscape"
            alt="关于51CG吃瓜特色"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-black/20" />
        </div>
        <div className="relative z-10 w-full px-4 md:px-8 lg:px-12">
          <Breadcrumb items={breadcrumbItems} />
          <h1 className="text-3xl md:text-5xl font-black text-white mt-4">关于 51CG吃瓜特色</h1>
          <p className="text-sm md:text-base text-white/70 max-w-xl mt-3">
            专注吃瓜多年，我们深知什么才是真正值得您关注的内容
          </p>
        </div>
      </section>

      {/* Brand Story */}
      <section className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16 bg-background-50">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="flex-1">
            <span className="inline-block px-3 py-1 rounded-full text-xs font-semibold bg-secondary-100 text-secondary-900 border border-secondary-200 mb-4">
              品牌故事
            </span>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-4 leading-tight">
              做一个称职的<br />吃瓜群众
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              51CG吃瓜特色诞生于2024年，由一群热爱娱乐八卦、关注社会热点的资深媒体人创立。我们厌倦了网络上充斥着标题党、假爆料和带节奏的虚假资讯，决定打造一个真正为吃瓜群众服务的专业平台。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              我们的名字 51CG 来源于吃瓜的谐音，而 .吃瓜特色 则代表着我们对内容品质的追求——不只是简单搬运，更要提供深度、有趣、有料的吃瓜体验。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              经过两年的发展，51CG吃瓜已经成为全网最受欢迎的吃瓜导航平台之一，累计服务超过千万读者，日均更新数十篇高质量文章，覆盖明星黑料、娱乐爆料、深度解析与经典综艺莫里秀找爹系列。
            </p>
          </div>
          <div className="w-full lg:w-[420px] flex-shrink-0">
            <div className="rounded-xl overflow-hidden border border-background-200/70">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20editorial%20newsroom%20workspace%20with%20multiple%20monitors%20showing%20breaking%20news%20headlines%2C%20lime%20green%20accent%20lighting%2C%20dark%20moody%20atmosphere%2C%20sleek%20minimal%20design%2C%20professional%20media%20office%20aesthetic&width=600&height=450&seq=about-brand-01&orientation=landscape"
                alt="51CG编辑部"
                className="w-full aspect-[4/3] object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Values */}
      <section className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16 bg-background-100">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-semibold bg-secondary-100 text-secondary-900 border border-secondary-200 mb-3">
            使命与价值
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            我们的坚持
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            在信息爆炸的时代，我们相信好的内容依然值得被认真对待
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {[
            {
              icon: 'ri-time-line',
              title: '实时更新',
              desc: '7x24小时追踪全网热点，重大事件发生后30分钟内完成首篇报道，确保读者永远快人一步。',
            },
            {
              icon: 'ri-shield-check-line',
              title: '严谨求证',
              desc: '每篇爆料文章均标注信息来源，深度分析提供完整证据链。不传播未经核实的谣言，对读者负责。',
            },
            {
              icon: 'ri-lightbulb-line',
              title: '独特视角',
              desc: '不只是搬运，更有独家解读。我们的编辑团队能从纷繁复杂的信息中提炼出最有价值的观点。',
            },
            {
              icon: 'ri-emotion-happy-line',
              title: '趣味表达',
              desc: '吃瓜是娱乐，阅读体验同样重要。我们用生动有趣的语言，让严肃的爆料也变得轻松可读。',
            },
            {
              icon: 'ri-user-voice-line',
              title: '尊重隐私',
              desc: '我们关注事件本身而非过度消费当事人隐私，在爆料与伦理之间保持平衡，倡导理性吃瓜。',
            },
            {
              icon: 'ri-community-line',
              title: '网友共建',
              desc: '51CG不仅是内容平台，更是吃瓜社区。我们重视每一位读者的反馈与爆料投稿，共建吃瓜生态。',
            },
          ].map((item) => (
            <div key={item.title} className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/70">
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4">
                <i className={`${item.icon} text-lg md:text-xl`} />
              </div>
              <h3 className="text-base md:text-lg font-bold text-foreground-950 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Stats */}
      <section className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16 bg-background-50">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {[
            { number: '1000万+', label: '累计读者', icon: 'ri-user-line' },
            { number: '5000+', label: '原创文章', icon: 'ri-article-line' },
            { number: '50+', label: '专职编辑', icon: 'ri-team-line' },
            { number: '99%', label: '读者好评', icon: 'ri-heart-line' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-3">
                <i className={`${stat.icon} text-xl`} />
              </div>
              <p className="text-2xl md:text-3xl font-black text-primary-600">{stat.number}</p>
              <p className="text-sm text-foreground-500 mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Team */}
      <section className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16 bg-background-100">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-semibold bg-secondary-100 text-secondary-900 border border-secondary-200 mb-3">
            编辑团队
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            幕后的吃瓜专家们
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            一群对娱乐八卦充满热情的专业媒体人，用专业和敬业为您呈现最精彩的吃瓜内容
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-6">
          {[
            { name: '瓜哥', role: '主编', desc: '15年娱记经验', color: 'bg-primary-100 text-primary-700' },
            { name: '瓜妹', role: '副主编', desc: '资深八卦追踪', color: 'bg-accent-100 text-accent-700' },
            { name: '老王', role: '深度组组长', desc: '前知名媒体主编', color: 'bg-secondary-100 text-secondary-700' },
            { name: '小李', role: '内容运营', desc: '社交媒体达人', color: 'bg-primary-100 text-primary-700' },
          ].map((member) => (
            <div key={member.name} className="bg-background-50 rounded-lg p-5 text-center border border-background-200/70">
              <div className={`w-16 h-16 mx-auto rounded-full flex items-center justify-center text-xl font-bold mb-3 ${member.color}`}>
                {member.name[0]}
              </div>
              <h3 className="text-base font-bold text-foreground-950">{member.name}</h3>
              <p className="text-xs text-accent-600 font-medium mt-1">{member.role}</p>
              <p className="text-xs text-foreground-500 mt-1">{member.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Contact */}
      <section className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16 bg-background-50">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <span className="inline-block px-3 py-1 rounded-full text-xs font-semibold bg-secondary-100 text-secondary-900 border border-secondary-200 mb-3">
              联系我们
            </span>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              期待与您交流
            </h2>
            <p className="text-sm md:text-base text-foreground-600">
              无论是商务合作、爆料投稿还是意见反馈，我们随时欢迎
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            {[
              {
                icon: 'ri-mail-line',
                title: '商务合作',
                desc: '品牌合作、广告投放、内容授权等商务事宜',
                action: 'hello@leonqt.com',
              },
              {
                icon: 'ri-telegram-line',
                title: '爆料投稿',
                desc: '有独家料想分享？欢迎向我们爆料',
                action: 'hello@leonqt.com',
              },
              {
                icon: 'ri-message-3-line',
                title: '意见反馈',
                desc: '对平台有任何建议或发现内容问题',
                action: 'hello@leonqt.com',
              },
            ].map((item) => (
              <div key={item.title} className="bg-background-100 rounded-lg p-5 md:p-6 border border-background-200/70 text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
                  <i className={`${item.icon} text-xl`} />
                </div>
                <h3 className="text-base font-bold text-foreground-950 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-600 mb-3">{item.desc}</p>
                <span className="text-sm font-medium text-primary-600">{item.action}</span>
              </div>
            ))}
          </div>

          {/* Social Links */}
          <div className="mt-10 text-center">
            <p className="text-sm text-foreground-500 mb-4">关注我们的社交媒体</p>
            <div className="flex items-center justify-center gap-3">
              {[
                { icon: 'ri-wechat-fill', label: '微信公众号' },
                { icon: 'ri-weibo-fill', label: '微博' },
                { icon: 'ri-tiktok-fill', label: '抖音' },
                { icon: 'ri-instagram-line', label: '小红书' },
              ].map((s) => (
                <a
                  key={s.label}
                  href="#"
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-accent-500 hover:text-background-50 transition-colors"
                  aria-label={s.label}
                  rel="nofollow"
                >
                  <i className={`${s.icon} text-lg`} />
                </a>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16 bg-background-100">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <span className="inline-block px-3 py-1 rounded-full text-xs font-semibold bg-secondary-100 text-secondary-900 border border-secondary-200 mb-3">
              常见问题
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              您可能想知道
            </h2>
          </div>

          <div className="space-y-4">
            {[
              {
                q: '51CG吃瓜特色是什么？',
                a: '51CG吃瓜特色是汇集最新热门瓜料、明星黑料、娱乐爆料与网友热议话题的综合性吃瓜导航与深度解析平台，覆盖明星黑料、热门吃瓜、深度解析、娱乐爆料、莫里秀找爹五大专区。',
              },
              {
                q: '51CG吃瓜的内容可靠吗？',
                a: '51CG吃瓜对所有发布内容进行初步审核，标注信息来源。热门爆料会标注爆料标签，深度分析文章会提供证据链。我们鼓励读者保持独立思考，理性吃瓜。',
              },
              {
                q: '如何第一时间获取最新瓜料？',
                a: '建议收藏51CG吃瓜首页，关注热门吃瓜专区。重大事件通常会在首页置顶展示，分类专区也会实时更新各领域的最新动态。',
              },
              {
                q: '可以投稿或爆料吗？',
                a: '当然可以！我们欢迎有价值的爆料投稿。请通过页面底部的爆料投稿邮箱与我们联系，附上详细信息和证据材料。',
              },
              {
                q: '51CG吃瓜支持哪些访问入口？',
                a: '51CG吃瓜目前支持主站访问，覆盖51cg及cg51等渠道的入口。我们的内容全面适配桌面端和移动端，随时随地想看就看。',
              },
            ].map((faq, idx) => (
              <div key={idx} className="bg-background-50 rounded-lg p-4 md:p-5 border border-background-200/70">
                <h3 className="text-sm font-bold text-foreground-950 mb-2 flex items-start gap-2">
                  <span className="w-5 h-5 flex-shrink-0 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 text-xs font-bold mt-0.5">Q</span>
                  {faq.q}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed pl-7">{faq.a}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Category CTA */}
      <section className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16 bg-background-50">
        <div className="text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
            准备好开启吃瓜之旅了吗？
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mb-8 max-w-xl mx-auto">
            浏览我们的五大吃瓜专区，找到您感兴趣的内容
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="px-4 py-2 rounded-full text-sm font-medium bg-background-200 text-foreground-700 hover:bg-accent-500 hover:text-foreground-950 transition-colors whitespace-nowrap"
              >
                {cat.name}
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
